var map = {
	"./WhatsApp Image 2026-10-11 at 11.39.57.jpeg": 985,
	"./WhatsApp Image 2026-10-11 at 11.39.58 (1).jpeg": 830,
	"./WhatsApp Image 2026-10-11 at 11.39.58 (2).jpeg": 457,
	"./WhatsApp Image 2026-10-11 at 11.39.58 (3).jpeg": 740,
	"./WhatsApp Image 2026-10-11 at 11.39.58 (4).jpeg": 207,
	"./WhatsApp Image 2026-10-11 at 11.39.58 (5).jpeg": 834,
	"./WhatsApp Image 2026-10-11 at 11.39.59 (1).jpeg": 393,
	"./WhatsApp Image 2026-10-11 at 11.39.59 (2).jpeg": 934,
	"./WhatsApp Image 2026-10-11 at 11.39.59 (3).jpeg": 163,
	"./WhatsApp Image 2026-10-11 at 11.39.59 (4).jpeg": 240,
	"./WhatsApp Image 2026-10-11 at 11.39.59 (5).jpeg": 213,
	"./WhatsApp Image 2026-10-11 at 11.39.59.jpeg": 763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5;